import { atom } from "jotai";

export const openSearchFilterAtom = atom<boolean>(false);
